import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavItem from "../../components/SubHeader/NavItem";
import "./SubHeader.css";

function SubHeader() {
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
  const [isAttendanceDropdownOpen, setIsAttendanceDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleToggle = () => {
      setIsMobileMenuVisible((prev) => !prev);
    };

    window.addEventListener("toggle-subheader", handleToggle);
    return () => window.removeEventListener("toggle-subheader", handleToggle);
  }, []);

  // ✅ Navigate to Attendance page
  const handleAttendanceClick = () => {
    // navigate("/Attendance"); 
  };

  return (
    <>
      {/* Desktop SubHeader */}
      <div className="employee-sub-header desktop-only">
        <NavItem navTitle="Overview" navLink="/EmployeeIndex" navIcon="fa-solid fa-house" selected={false} />
        <NavItem navTitle="My Team" navLink="/MyTeam" navIcon="fa-solid fa-users" selected={false} />

        {/* Attendance Dropdown (Hover) */}
        <div className="nav-dropdown">
          <button className="dropdown-btn" onClick={handleAttendanceClick}>
            <i className="fa-regular fa-clock"></i> Attendance
            <i className="fa-solid fa-caret-down dropdown-arrow"></i>
          </button>
          <div className="dropdown-menu">
            <NavItem navTitle="Overtime Application" navLink="/OvertimeList" navIcon="fa-solid fa-clock-rotate-left" />
            <NavItem navTitle="Official Business" navLink="/BusinessList" navIcon="fa-solid fa-briefcase" />
            <NavItem navTitle="Attendance Summary" navLink="/AttendanceSummary" navIcon="fa-solid fa-list-check" />
          </div>
        </div>

        <NavItem navTitle="Benefits" navLink="/Benefits" navIcon="fa-solid fa-list" selected={false} />
        <NavItem navTitle="To Do" navLink="/ToDo" navIcon="fa-solid fa-clipboard" selected={false} />
        <NavItem navTitle="Payroll" navLink="/Payroll" navIcon="fa-solid fa-coins" selected={false} />

        <NavItem navTitle="Leaves" navLink="/LeavesList" navIcon="fa-regular fa-calendar-days" selected={false} />
        <NavItem navTitle="Settings" navLink="/AdminSettings" navIcon="fa-solid fa-gear" selected={false} />
      </div>

      {/* Mobile Drawer */}
      <div className={`subheader-overlay ${isMobileMenuVisible ? "visible" : ""}`}>
        <div className="subheader-drawer">
          <NavItem navTitle="Overview" navLink="/EmployeeIndex" navIcon="fa-solid fa-house" selected={true} />
          <NavItem navTitle="My Team" navLink="/MyTeam" navIcon="fa-solid fa-users" selected={false} />

          {/* Attendance Dropdown (Click for Mobile) */}
          <div className="nav-dropdown">
            <button 
              className="dropdown-btn"
              onClick={() => {
                handleAttendanceClick(); // ✅ Go to Attendance page
                setIsAttendanceDropdownOpen(prev => !prev);
              }}
            >
              <i className="fa-regular fa-clock"></i> Attendance 
              <i className={`fa-solid fa-caret-down dropdown-arrow ${isAttendanceDropdownOpen ? "rotate" : ""}`}></i>
            </button>
            
            {isAttendanceDropdownOpen && (
              <div className="dropdown-menu">
                <NavItem navTitle="Overtime Application" navLink="/OvertimeList" navIcon="fa-solid fa-clock-rotate-left" />
                <NavItem navTitle="Official Business" navLink="/BusinessList" navIcon="fa-solid fa-briefcase" />
                <NavItem navTitle="Attendance Summary" navLink="/AttendanceSummary" navIcon="fa-solid fa-list-check" />
              </div>
            )}
          </div>

          <NavItem navTitle="Benefits" navLink="/Benefits" navIcon="fa-solid fa-list" selected={false} />
          <NavItem navTitle="ToDo" navLink="/ToDo" navIcon="fa-solid fa-inbox" selected={false} />
          <NavItem navTitle="Payroll" navLink="/Payroll" navIcon="fa-solid fa-clipboard" selected={false} />
          <NavItem navTitle="Leaves" navLink="/Leaves" navIcon="fa-regular fa-calendar-days" selected={false} />
          <NavItem navTitle="Settings" navLink="/EmployeeIndex" navIcon="fa-solid fa-gear" selected={false} />
        </div>
      </div>
    </>
  );
}

export default SubHeader;
